import React, { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'

import WeekView from './WeekView'
import MonthView from './MonthView'

import {
  REPEAT_BOOKING,
  WEEK_EN,
  WEEK_TH,
  getEveryType,
  getWeekly,
  getMonthlyOptions,
} from '../../../../helpers'

import { StylesRepeatOn } from './styles'

const setDefaultSelectedIndex = (selectedIndex) => {
  if (selectedIndex < 0) {
    return 0
  } else {
    return selectedIndex
  }
}

const RepeatOn = (props) => {
  const {
    date,
    language,
    repeatEveryType,
    repeatOnSelectedWeekly,
    repeatOnSelectedMonthly,
    onSelectedWeekly,
    onSelectedMonthly,
    colorTheme
  } = props

  const defaultWeekly = [getWeekly(date)]
  const { isWeekly, isMonthly } = getEveryType(repeatEveryType)
  const monthlyOptions = getMonthlyOptions(date, language)
  const WEEK = language === 'EN' ? WEEK_EN : WEEK_TH

  const selectedIndex = !isEmpty(repeatOnSelectedMonthly)
    ? monthlyOptions.findIndex(({ key }) => key === repeatOnSelectedMonthly.key)
    : 0

  const defaultSelectedIndex = setDefaultSelectedIndex(selectedIndex)

  const [selectedMonthlyIndex, setSelectedMonthlyIndex] = useState(defaultSelectedIndex)
  const [selectedWeekly, setSelectedWeekly] = useState(repeatOnSelectedWeekly)
  const [isOpenDropdown, setIsOpenDropdown] = useState(false)

  const handleSelectedWeekly = (newDay, selectedWeekly) => {
    if (selectedWeekly.includes(newDay)) {
      const result = selectedWeekly.filter((day) => day !== newDay)

      if (!isEmpty(result)) {
        setSelectedWeekly(result)
        onSelectedWeekly(result)
      }
    } else {
      setSelectedWeekly([newDay, ...selectedWeekly])
      onSelectedWeekly([newDay, ...selectedWeekly])
    }
  }

  const handleSelectedMonthly = (key, currentIndex) => {
    setSelectedMonthlyIndex(currentIndex)
    setIsOpenDropdown(false)
    onSelectedMonthly(monthlyOptions[currentIndex])
  }

  const onPressMonthlyDropdown = () => {
    setIsOpenDropdown(prev => prev = !prev)
  }

  useEffect(() => {
    if (!isWeekly) {
      setSelectedWeekly(defaultWeekly)
    }

    if (isMonthly){
      // Set default monthly
      onSelectedMonthly(monthlyOptions[0])
    }
  }, [repeatEveryType])

  return (
    <StylesRepeatOn colorTheme={colorTheme}>
      { isWeekly && <label className='title'>{REPEAT_BOOKING.ON[language]} </label> }

      { isWeekly ? (
          <WeekView
            week={WEEK}
            selectedWeekly={selectedWeekly}
            setSelectedWeekly={setSelectedWeekly}
            onSelectedWeekly={handleSelectedWeekly}
          />
        )
        : (
          <MonthView
            isOpen={isOpenDropdown}
            list={monthlyOptions}
            selectedIndex={selectedMonthlyIndex}
            onDropdown={onPressMonthlyDropdown}
            onSelected={handleSelectedMonthly}
            language={language}
            setIsOpenDropdown={setIsOpenDropdown}
            colorTheme={colorTheme}
          />
        )
      }
    </StylesRepeatOn>
  )
}

export default RepeatOn
